import { render, staticRenderFns } from "./CommunityGroup.vue?vue&type=template&id=7af1248b&scoped=true&"
import script from "./CommunityGroup.vue?vue&type=script&lang=js&"
export * from "./CommunityGroup.vue?vue&type=script&lang=js&"
import style0 from "./CommunityGroup.vue?vue&type=style&index=0&id=7af1248b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af1248b",
  null
  
)

export default component.exports